import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-20">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            简历匹配度评估助手
          </h1>
          <p className="text-xl text-gray-700 mb-8 max-w-3xl mx-auto">
            专业的简历与心仪岗位匹配度分析工具，帮助招聘人员快速识别最适合的候选人，也帮助求职者优化简历、提升竞争力
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/register"
              className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
            >
              免费注册
            </Link>
            <Link
              to="/login"
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold border border-blue-600 hover:bg-blue-50 transition-colors"
            >
              立即登录
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;